import { Route, Routes } from "react-router-dom";
import { CamPage } from "./pages/cam/CamPage";
import styles from "./App.module.scss";

export function App() {
  return (
    <Routes>
      {/* Full-screen, no chrome: it's meant to sit on a display. */}
      <Route path="/cam" element={<CamPage />} />
      <Route path="/" element={<HomePage />} />
      <Route
        path="*"
        element={
          <main className={styles["app"]}>
            <p>Nothing here.</p>
          </main>
        }
      />
    </Routes>
  );
}

function HomePage() {
  return (
    <main className={styles["app"]}>
      <h1>hi</h1>
    </main>
  );
}
